import React, { lazy, Suspense, useCallback, useRef, useState } from "react";
import { SubHeading } from "../../shared/Components";
import { CommonModal } from "../../shared/Components/Modal";
import PermissionModal from "../../shared/Components/Modal/ConfigurationModal/PermissionModal";
import { getAxios } from "../../shared/Services/commonService";
import { API_PERMISSION } from "../../utils/api/ApiConstant";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

const PermissionBody = lazy(() => import("./PermissionBody"));
const Permission = () => {
  const LoggedInUserId = useSelector((state) => state.user?.user?.id);
  const menu = useSelector((state) => state.user.formList) || [];

  const {
    data,
    isLoading,
    refetch: permissionRefetch,
  } = useQuery({
    queryKey: ["permissioanData", LoggedInUserId],
    queryFn: () => getAxios(API_PERMISSION),
    enabled: !!LoggedInUserId,
  });

  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });

  const handleModal = (rowData, title = "") => {
    setIsShow({
      isOpen: true,
      modalContent: PermissionModal,
      modalTitle: title,
      rowData,
    });
  };

  return (
    <>
      <SubHeading
        isAdd={true}
        handleShowHide={() => handleModal({}, "Create")}
      />

      <Suspense fallback={<div>Loading...</div>}>
        <PermissionBody
          onEdit={(rowData) => handleModal(rowData, "Edit")}
          data={data}
          isLoading={isLoading}
          fetchData={permissionRefetch}
        />
      </Suspense>

      {isShow?.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          size="sm"
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleModalHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                  apiFlag: !prev.apiFlag,
                })),
              rowData: isShow.rowData,
              fetchData: permissionRefetch,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default Permission;
